<template>
  <div class="union-match">
    <van-image width="100vw" fit="cover" :src="imageView(match.backgroundImage2)"></van-image>
    <div class="match">
      <div class="info">
        <div class="left">
          <van-image :src="(match.icon && match.icon.length === 28) ? imgView(match.icon) : ''" width="36px" height="36px" radius="8px"></van-image>
        </div>
        <div class="right">
          <div class="title">
            <span>{{match.chineseName}}</span>
          </div>

        </div>
      </div>
      <div style="display: flex; justify-content: space-between; align-items: center">
        <div style="width: 88%;">
          <div class="address">
            <img src="../../assets/date.png" style="width: 16px; height: 16px;">
            <div style="margin-left: 4px">{{ getFormatDate(match.beginDate) }} ~ {{ getFormatDate(match.endDate) }}</div>
          </div>
          <div class="address" style="margin-top: 4px;">
            <img src="../../assets/position.png" style="width: 16px; height: 16px;">
            <div style="margin-left: 4px; overflow:hidden; white-space: nowrap; text-overflow: ellipsis; -o-text-overflow:ellipsis;">
              {{ match.province || '' }}-{{ match.city || '' }}&nbsp;{{ match.location || '' }}
            </div>
          </div>
        </div>
<!--        <van-button @click="goMyGame" round type="info" style="width: 90px; height: 28px;">-->
<!--          <span style="font-size: 12px">我的参赛</span>-->
<!--        </van-button>-->
      </div>
    </div>
    <div class="projects">
      <div class="title">
        <span>赛事组别</span>
      </div>
      <div class="project" :class="project.unitType === 0 ? 't' : (project.unitType === 1 ? 'p' : 'm')" v-for="(project, index) in list" :key="index" @click="goMatch(project)">
        <div style="display: flex; align-items: center">
          <img class="logo" v-if="project.unitType === 0" src="../../assets/project-list/t.png" alt="">
          <img class="logo" v-else-if="project.unitType === 1" src="../../assets/project-list/p.png" alt="">
          <img class="logo" v-else-if="project.unitType === 2" src="../../assets/project-list/m.png" alt="">
          <span :class="project.unitType === 0 ? 't-n' : (project.unitType === 1 ? 'p-n' : 'm-n')" style="margin-left: 8px">{{ project.group }}</span>
        </div>
        <div>
          <img class="icon" v-if="project.unitType === 0" src="../../assets/project-list/t_icon.png" alt="">
          <img class="icon" v-else-if="project.unitType === 1" src="../../assets/project-list/p_icon.png" alt="">
          <img class="icon" v-else-if="project.unitType === 2" src="../../assets/project-list/m_icon.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {Toast, Image as VanImage, Tab, Tabs, Tag, List, Button} from 'vant'
Vue.use(VanImage).use(Tab).use(Tabs).use(Tag).use(List).use(Button)
import {getBMMatchList2, getBMUnionMatch, getCrmNewsList} from '@/api/match'
import {DateUtil, QNImageUtil} from "@/utils";

export default {
  data() {
    return {
      unionMatchId: '',
      match: {},
      list: [],
      newsList: [],
      active: 0,
      finished: true,
      loading: false,
      pageNum: 1,
      pageSize: 10
    }
  },
  mounted() {
    this.unionMatchId = this.$route.query.unionMatchId
    if (this.unionMatchId) {
      this.getBMMatchList2()
      this.getBMUnionMatch()
    } else {
      Toast.fail('缺少赛事Id')
    }
  },
  methods: {
    goDraws() {
      if (!this.unionMatchId) return
      this.$router.push({ path: `/match-detail/${this.unionMatchId}/draws` })
    },
    appShare() {
      console.log(this.match.beginDate);
      const shareObj = {
        title: this.match.chineseName + this.getPromotion(this.match.beginDate, this.match.endDate),
        abstract: '赛程赛果',
        link: process.env.VUE_APP_BM_MATCH + '#/union-match/home?unionMatchId=' + this.unionMatchId,
        image: this.match.backgroundImage2 ? QNImageUtil.imageView(this.match.icon) : ''
      }
      this.wxShare(shareObj)
    },
    getPromotion(createDate, endDate) {
      const startTime = new Date(createDate)
      const endTime = new Date(endDate)
      const currentTime = new Date()
      if (currentTime < startTime) {
        return '-敬请期待';
      } else if (currentTime >= startTime && currentTime <= endTime) {
        return '-激战正酣';
      } else {
        return '-完美闭幕';
      }
    },
    getFormatDate(date) {
      return DateUtil.parseDateTime(date, '{y}-{m}-{d}')
    },
    imageView(img, w, h) {
      if (!img) return ''
      return QNImageUtil.imageView(img, w, h)
    },
    originView(video) {
      if (!video) return ''
      return QNImageUtil.originView(video)
    },
    getBMMatchList2() {
      const params = {
        unionMatchId: this.unionMatchId
      }
      getBMMatchList2(params).then(res => {
        if (res) {
          const { data } = res
          this.list = data.list || []
        }
      })
    },
    getBMUnionMatch() {
      const params = {
        unionMatchId: this.unionMatchId,
        preview: this.$route.query.preview || 0
      }
      getBMUnionMatch(params).then(res => {
        if (res) {
          const { data } = res
          this.match = data.match || {}
          document.title = data.match.chineseName
          this.appShare()
          this.finished = false
        }
      })
    },
    imgView(img) {
      if (!img) return ''
      return QNImageUtil.imageView(img)
    },
    goMatch(item) {
      this.$router.push(`/match/home?matchId=${item.id}`)
    },
    showRegulations() {
      if (this.active === 1) {
        this.$nextTick(() => {
          const regulations = document.getElementById('regulations')
          regulations.innerHTML = this.match.regulations
        })
      }
    },
    getCrmNewsList() {
      const params = {
        accountId: this.match.accountId,
        unionMatchId: this.unionMatchId,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      getCrmNewsList(params).then(res => {
        if (res) {
          const { data } = res
          this.newsList = this.newsList.concat(data.list)
          if (this.newsList.length < this.pageSize) {
            this.finished = true
          }
          this.pageNum++
        }
      })
    },
    goMyGame() {
      this.$router.push(`/entry-page/entry-list?unionMatchId=${this.unionMatchId}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.union-match {
  background-color: #F6F6F8;
  min-height: 100vh;
  .match {
    background-color: #fff;
    border-radius: 4px 4px 8px 8px;
    padding: 16px;
    border-bottom: 1px #F6F6F8 solid;
    .info {
      display: flex;
      flex-flow: row;
      .left {
        text-align: center;
        width: 44px;
        .care {
          width: 44px;
          height: 20px;
          border-radius: 2px;
          background-color: #BEF002;
          color: #191919;
          font-size: 12px;
          line-height: 20px;
          text-align: center;
          margin-top: 12px;
        }
      }
      .right {
        width: calc(100% - 36px);
        padding-left: 12px;
        box-sizing: border-box;
        .title {
          height: 48px;
          font-size: 18px;
          font-weight: 500;
          color: #191919;
          overflow:hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;
        }
        .size-count {
          margin-top: 4px;
          display: flex;
          flex-flow: row;
          font-size: 12px;
          color: #474747;
          .count {
            margin-left: 12px;
          }
        }
      }
    }
    .address {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #999999;
    }
  }
  .projects {
    background-color: #FFFFFF;
    padding: 0 12px 12px;
    .title {
      background-color: #FFFFFF;
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 15px;
      color: #333333;
      padding: 18px 0 13px 0;
      border-bottom: 0.5px #EEEEEE solid;
      .icon {
        width: 2px;
        height: 12px;
        background-color: #2D60DF;
        margin-right: 6px;
      }
    }
    .project {
      height: 66px;
      padding: 16px 12px 12px 12px;
      box-sizing: border-box;
      margin-top: 12px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .logo {
        width: 24px;
        height: 24px;
      }
      .icon {
        width: 20px;
        height: 20px;
      }
    }
    .p-n {
      font-size: 14px;
      color: #36b02f;
    }
    .m-n {
      font-size: 14px;
      color: #7661f8;
    }
    .t-n {
      font-size: 14px;
      color: #fe7d1c;
    }
    .p {
      background-image: url('../../assets/project-list/person_bgi.png');
    }
    .m {
      background-image: url('../../assets/project-list/more_bgi.png');
    }
    .t {
      background-image: url('../../assets/project-list/team_bgi.png');
    }
  }
}
</style>
